var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgSberpay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 18,
    viewBox: "0 0 51 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6953 10.7184V14.5162H24.6064V2.32263H28.4986C32.1922 2.32263 33.7621 3.69995 33.7621 6.4523C33.7621 9.29103 31.9241 10.7184 28.4986 10.7184H26.6953ZM26.6953 4.32724V8.71376H28.6577C30.5961 8.71376 31.5991 8.05233 31.5991 6.39776C31.5991 4.89998 30.727 4.32497 28.6926 4.32497L26.6953 4.32724Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9977 6.56341C35.5588 6.14877 36.583 5.80652 38.0526 5.80652C40.5441 5.80652 41.7732 6.64897 41.7732 8.83409V14.3824H39.8962V12.8686C39.4865 13.8427 38.4445 14.5162 37.0796 14.5162C35.3562 14.5162 34.3342 13.5575 34.3342 11.9099C34.3342 9.99246 35.7503 9.45494 37.8478 9.45494H39.7759V9.08639C39.7759 7.89291 39.197 7.52211 38.0526 7.52211C36.4829 7.52211 35.5789 8.12766 35 9.01836L34.9977 6.56341ZM39.7737 11.4141V10.734H38.086C36.9081 10.734 36.3448 10.9534 36.3448 11.708C36.3448 12.3465 36.8213 12.7501 37.7097 12.7501C39.0568 12.7501 39.6891 11.9932 39.7737 11.4141Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3455 5.80652H44.5703L46.9064 11.7805L48.8154 5.80652H50.9289L47.5205 15.4404C46.7685 17.5295 46.0031 18.0001 44.8773 18.0001C44.3478 18.0001 43.765 17.8432 43.5135 17.6182V15.7177C43.7878 15.9911 44.1538 16.1473 44.537 16.1542C45.1488 16.1542 45.6093 15.736 45.9342 14.563L42.3455 5.80652Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9082 3.49695C16.3301 4.04971 16.6873 4.65024 16.9724 5.28647L8.88282 11.33L5.50195 9.18218V6.59822L8.88282 8.74607L15.9082 3.49695Z",
    fill: "#21A038"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05169 9.00013C2.05169 8.88418 2.05448 8.769 2.06006 8.65449L0.0111587 8.55273C0.00418488 8.70115 2.476e-06 8.851 2.476e-06 9.00222C-0.000869275 10.1838 0.228462 11.354 0.674846 12.4455C1.12123 13.5371 1.77587 14.5286 2.60123 15.3631L4.05456 13.8909C3.41923 13.2497 2.91523 12.4874 2.5715 11.6481C2.22778 10.8088 2.05113 9.90885 2.05169 9.00013Z",
    fill: "url(#paint0_linear_948_33)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88051 2.07887C8.99486 2.07887 9.1085 2.08311 9.22148 2.08876L9.324 0.0115843C9.17713 0.00451663 9.02926 0.000983238 8.88051 0.000983238C7.71403 -0.000458389 6.55882 0.231624 5.48114 0.683903C4.40344 1.13618 3.42453 1.79975 2.60059 2.63651L4.05392 4.10941C4.68671 3.46532 5.43889 2.95434 6.26722 2.60587C7.09554 2.2574 7.98362 2.0783 8.88051 2.07887Z",
    fill: "url(#paint1_linear_948_33)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88073 15.9214C8.76638 15.9214 8.65268 15.9214 8.53905 15.9122L8.43652 17.9887C8.5839 17.9962 8.73198 18 8.88073 18C10.0467 18.0012 11.2014 17.769 12.2785 17.3166C13.3556 16.8642 14.3339 16.2005 15.1572 15.3638L13.7066 13.8916C13.0737 14.5353 12.3216 15.046 11.4935 15.3944C10.6653 15.7427 9.7774 15.9218 8.88073 15.9214Z",
    fill: "url(#paint2_linear_948_33)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7313 3.28647L14.458 1.99662C12.8797 0.701448 10.9097 -0.00359526 8.87891 1.37872e-05V2.07861C10.2541 2.07688 11.5973 2.49805 12.7313 3.28647Z",
    fill: "url(#paint3_linear_948_33)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7614 9.00004C17.7625 8.45931 17.7159 7.91952 17.6219 7.38721L15.7105 8.81487C15.7105 8.87639 15.7105 8.93786 15.7105 9.00004C15.711 9.9671 15.5109 10.9235 15.1234 11.8072C14.7358 12.6908 14.1693 13.4821 13.4607 14.1297L14.8394 15.674C15.7607 14.8311 16.4969 13.8015 17.0003 12.6518C17.5037 11.502 17.763 10.2579 17.7614 9.00004Z",
    fill: "#21A038"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88077 15.9214C7.92648 15.9217 6.98277 15.7189 6.11069 15.3262C5.23867 14.9334 4.45773 14.3594 3.81848 13.6414L2.29541 15.0379C3.12701 15.9717 4.14298 16.718 5.27746 17.2283C6.41193 17.7385 7.63956 18.0014 8.88077 17.9999V15.9214Z",
    fill: "url(#paint4_linear_948_33)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30144 3.86996L2.92342 2.32568C2.00188 3.16841 1.26542 4.19803 0.761789 5.34778C0.258166 6.49751 -0.00137305 7.7417 5.46267e-06 8.99964H2.0517C2.05127 8.03265 2.25132 7.07627 2.63888 6.19259C3.02644 5.30893 3.59286 4.51763 4.30144 3.86996Z",
    fill: "url(#paint5_linear_948_33)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_948_33",
    x1: 3.01617,
    y1: 15.1037,
    x2: 0.720703,
    y2: 8.55615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9DA26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_948_33",
    x1: 3.18638,
    y1: 3.00403,
    x2: 8.97935,
    y2: 0.825722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0098F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0290EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_948_33",
    x1: 8.30126,
    y1: 16.7455,
    x2: 14.8385,
    y2: 15.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#86C239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#219F38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_948_33",
    x1: 8.45214,
    y1: 0.696176,
    x2: 14.0468,
    y2: 2.39974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0290EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C89CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_948_33",
    x1: 2.81007,
    y1: 14.7849,
    x2: 8.90537,
    y2: 17.0327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EAE616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D8DF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BAD52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_948_33",
    x1: 0.764331,
    y1: 9.25124,
    x2: 3.26044,
    y2: 2.84419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#81C45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0FA7DF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberpay);
export default __webpack_public_path__ + "static/media/sberpay.663098260b50969a4194ee51842e23f7.svg";
export { ForwardRef as ReactComponent };